// Copyright (c) 2017 Deere & Company

import UserSettings from './user-settings';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.user.preferences
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    ...parentProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, {}, mapBoundActionCreatorsToActionsProp)(UserSettings);



// WEBPACK FOOTER //
// ./src/user/shared/components/user-settings/index.js